export default __webpack_public_path__ + "static/media/susy.bc19850e.svg";